// import jsonFile from '../assets/data.json';
import jsonFile from '../assets/data2.json';

export function startNewSession(href = 'tasks.html') {
  localStorage.removeItem('session');
  localStorage.removeItem('min');
  localStorage.removeItem('max');
  localStorage.removeItem('previouslyAnswered');
  localStorage.removeItem('resultTexts');

  $.get('./assets/data2.json', data => {

    let randomPack = getRandomPack(data);
    let quastions = randomPack.quastions.map(id => data.quastions[id - 1])

    let categories = [
      "Образование",
      "Здравоохранение",
      "Цифровой_город",
      "ЖКХ",
      "Культура",
      "Доступная_среда",
      "Транспорт",
      "Городская_среда",
      "Градостроительство",
      "Экология",
    ];

    let session = {};

    for (let key of categories) {
      session[key] = {
        answered: null,
        quastion: quastions.find(item => item.category === key),
        image: data.categoryImages[key],
      }
    }

    localStorage.setItem('session', JSON.stringify(session));
    localStorage.setItem('min', randomPack.min);
    localStorage.setItem('max', randomPack.max);
    localStorage.setItem('resultTexts', JSON.stringify(data.resultTexts));

    location.href = href;
  });
}

function getRandomPack(data) {
  let randomNumber = Math.floor(Math.random() * data.packs.length);
  return data.packs[randomNumber];
}


export function getResult(session) {
  let value = 0;
  let weight = 0;
  let min = localStorage.getItem('min');
  let max = localStorage.getItem('max');

  let range = max - min;
  let step = range / 5;

  for (let key in session) {
    for (let answer of session[key].answered) {
      for (let groupKey in answer.reactions) {
        value += answer.reactions[groupKey];
      }
    }
  }

  let text = '';
  let image = '';

  let resultTexts = JSON.parse(localStorage.getItem('resultTexts'));

  if (value >= max - step) {
    image = 'emoji-4.svg';
    text = resultTexts[4];
    weight = 4;
  } else if (value >= max - step * 2) {
    image = 'emoji-3.svg';
    text = resultTexts[3];
    weight = 3;
  } else if (value >= max - step * 3) {
    image = 'emoji-2.svg';
    text = resultTexts[2];
    weight = 2;
  } else if (value >= max - step * 4) {
    image = 'emoji-1.svg';
    text = resultTexts[1];
    weight = 1;
  } else {
    image = 'emoji-0.svg';
    text = resultTexts[0];
    weight = 0;
  }

  return { value, image, text, weight };
}


export function getReactions(session) {
  let result = {
    "Служащие": 0,
    "Молодые семьи": 0,
    "Автомобилисты": 0,
    "Люди с ограниченными возможностями": 0,
    "Городские активисты": 0,
    "Пешеходы": 0,
    "Старшее поколение": 0,
    "Предприниматели": 0,
    "Молодежь": 0,
    "Работники городских учреждений": 0
  };

  let reactions = [];

  for (let key in session) {
    if (session[key].answered) {
      for (let answer of session[key].answered) {
        reactions.push(answer.reactions);
      }
    }
  }

  for (let reaction of reactions) {
    for (let key in reaction) {
      result[key] += reaction[key];
    }
  }

  return result;
}

export function getCurrentReactions(session) {
  let result = {
    "Служащие": 0,
    "Молодые семьи": 0,
    "Автомобилисты": 0,
    "Люди с ограниченными возможностями": 0,
    "Городские активисты": 0,
    "Пешеходы": 0,
    "Старшее поколение": 0,
    "Предприниматели": 0,
    "Молодежь": 0,
    "Работники городских учреждений": 0
  };

  let prev = JSON.parse(localStorage.getItem('previouslyAnswered'));

  if (prev) {
    prev.forEach(item => {
      for (let key in item.reactions) {
        result[key] += item.reactions[key];
      }
    });
  }

  return result;
}

export function getReactionsForCategory(session, category) {
  let result = {
    "Служащие": 0,
    "Молодые семьи": 0,
    "Автомобилисты": 0,
    "Люди с ограниченными возможностями": 0,
    "Городские активисты": 0,
    "Пешеходы": 0,
    "Старшее поколение": 0,
    "Предприниматели": 0,
    "Молодежь": 0,
    "Работники городских учреждений": 0
  };

  let answers = session[category].answered;

  if (answers) {
    answers.forEach(item => {
      for (let key in item.reactions) {
        result[key] += item.reactions[key];
      }
    });
  }

  return result;
}

export function getWeightImage(weightValue) {
  if (weightValue >= 2) return 'emoji-4.svg';
  else if (weightValue >= 1) return 'emoji-3.svg';
  else if (weightValue >= 0) return 'emoji-2.svg';
  else if (weightValue >= -1) return 'emoji-1.svg';
  else return 'emoji-0.svg';
}

export function getCurrentWeight(session) {
  let weight = 0;

  let prev = JSON.parse(localStorage.getItem('previouslyAnswered'));

  if (prev) {
    for (let item of prev) {
      weight += item.weight
    }
  }

  return weight;
}

export function getCurrentWeights(session) {
  let weights = {
    "Образование": 0,
    "Здравоохранение": 0,
    "Цифровой_город": 0,
    "ЖКХ": 0,
    "Культура": 0,
    "Доступная_среда": 0,
    "Транспорт": 0,
    "Городская_среда": 0,
    "Градостроительство": 0,
    "Экология": 0,
  };

  for (let key in session) {
    if (session[key].answered) {
      for (let answer of session[key].answered) {
        weights[key] += answer.weight;
      }
    }
  }

  return weights;
}